import { MenuKey } from './menu';

const pages: MenuStructure = {
  lia: {
    assessmentSchedulePage: {
      title: 'Assessment Schedule',
      description:
        'Plan and organize assessments easily. Set up schedules, pick courses, and assign people to efficiently manage your evaluation process.'
    },
    masterQuestion: {
      title: 'Master Question',
      description:
        'Create and manage questions. Easily add, edit, or remove questions to build comprehensive question banks.'
    },
    masterGroupQuestion: {
      title: 'Master Group Question',
      description:
        'Create and manage group questions. Easily add, edit, or remove group question to build comprehensive grouping your questions.'
    }
  },
  lcms: {
    lcmsOverview: {
      title: 'Overview',
      description:
        'Create and manage courses. Easily add, edit, or remove courses to build comprehensive knowledge repository.'
    },
    lcmsCourse: {
      title: 'Courses',
      description:
        'Manage comprehensive course information including basic details, delivery specifications, and approval workflows. Configure course categories, competency mapping, learning objectives, and integrate with LMS features like quizzes, evaluations, and learning materials.'
    },
    lcmsCourseCombine: {
      title: 'Course TNA',
      description:
        'Create and manage courses. Easily add, edit, or remove courses to build comprehensive knowledge repository.'
    },
    lcmsCoursePlan: {
      title: 'Course Planning',
      description:
        'Create or import yearly training plans. Manage program courses and modular training with automatic stakeholder notifications and calendar integration.'
    }
  },
  dacum: {
    overview: {
      title: 'Overview',
      description:
        'Visualize masterplan status across schools and drill down into branched masterplans by status.'
    },
    competencyManagement: {
      title: 'Competency Management',
      description:
        'Develop and manage competency frameworks. Define, track, and assess job-specific skills, knowledge, and abilities across your organization.'
    },
    schoolManagement: {
      title: 'School Competency Management',
      description:
        'Administer educational institutions with tools for faculty management, curriculum planning, student tracking, and resource allocation to ensure educational objectives are met.'
    },
    reviewMasterPlan: {
      title: 'Review Masterplan',
      description:
        'Evaluate and refine organizational training strategies. Analyze competency gaps, review development plans, and align learning initiatives with business objectives.'
    },
    masterPlan: {
      title: 'Masterplan',
      description:
        'Browse and manage master plans that align competency-based learning programs with organizational needs.'
    },
    report: {
      title: 'Report',
      description:
        'Generate comprehensive analytics and insights on competency development, training effectiveness, and organizational readiness with customizable reporting tools.'
    },
    masterAdminUser: {
      title: 'Master Admin User',
      description:
        'Manage master admin users. Add, edit, or remove users to maintain control over administrative access and permissions.'
    },
    masterArea: {
      title: 'Master Area',
      description:
        'Create and manage master areas. Easily add, edit, or remove areas to build comprehensive organizational structure.'
    }
  }
};

const PAGES = pages;

export interface PageLabel {
  title: string;
  description: string;
}

export interface PageStructure {
  assessmentSchedulePage?: PageLabel;
  masterQuestion?: PageLabel;
  masterGroupQuestion?: PageLabel;
  lcmsOverview?: PageLabel;
  lcmsCourse?: PageLabel;
  lcmsCourseCombine?: PageLabel;
  lcmsCoursePlan?: PageLabel;
  overview?: PageLabel;
  competencyManagement?: PageLabel;
  schoolManagement?: PageLabel;
  reviewMasterPlan?: PageLabel;
  masterPlan?: PageLabel;
  report?: PageLabel;
  masterAdminUser?: PageLabel;
  masterArea?: PageLabel;
}

export type MenuStructure = Partial<Record<MenuKey, PageStructure>>;
export default PAGES;
